import TopLevelMethod from "../../core/TopLevelMethod";
import {
  getFailActionName,
  getStartActionName,
  getSuccessActionName,
} from "../../core/make-action";
import ViewerMethod from "../../core/ViewerMethod";
import { removeItem } from "../../../../../../common/utils/array";
import { combineReducers } from "redux";
import { DetailedLoadStatus } from "../../../../../../common/utils/async-status";
import { lastUsedMarkers } from "./utils";
import { MarkerData } from "./types";

const markerIds = (state = [], action) => {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.GET_HIGHLIGHTS):
      return action.resultData.markers.map((marker) => marker.globalId);
    case getSuccessActionName(TopLevelMethod.CREATE_MARKER):
      return [...state, action.resultData.globalId];
    case getSuccessActionName(TopLevelMethod.DELETE_MARKER):
      return removeItem(state, action.apiCallArgs[0]);
    default:
      return state;
  }
};

const markerData = (state = {}, action) => {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.GET_HIGHLIGHTS):
      const markers = action.resultData.markers;
      const highlights = action.resultData.highlights;
      const lastUsed = lastUsedMarkers(highlights);
      return markers.reduce((obj, marker) => {
        marker.lastUsedAt = lastUsed[marker.globalId];
        obj[marker.globalId] = marker;
        return obj;
      }, {});
    case getSuccessActionName(TopLevelMethod.CREATE_MARKER):
      return {
        ...state,
        [action.resultData.globalId]: action.resultData,
      };
    case getSuccessActionName(TopLevelMethod.DELETE_MARKER):
      const cloned = { ...state };
      delete cloned[action.apiCallArgs[0]];
      return cloned;
    case getSuccessActionName(TopLevelMethod.UPDATE_MARKER):
      return {
        ...state,
        [action.resultData.globalId]: action.resultData,
      };
    case getSuccessActionName(ViewerMethod.HIGHLIGHT_CURRENT_SELECTION):
    case getSuccessActionName(ViewerMethod.UPDATE_HIGHLIGHT):
      const date = new Date();
      const updatedMarker = {
        ...state[action.resultData.markerId],
        lastUsedAt: date.toISOString(),
      };
      return { ...state, [action.resultData.markerId]: updatedMarker };
    default:
      return state;
  }
};

const colorOptions = (state = [], action) => {
  switch (action.type) {
    case getSuccessActionName(TopLevelMethod.GET_MARKERS):
      return action.resultData.colorOptions;
    default:
      return state;
  }
};

const colorOptionsLoadStatus = (state = DetailedLoadStatus.WAITING, action) => {
  switch (action.type) {
    case getStartActionName(TopLevelMethod.GET_MARKERS):
      return DetailedLoadStatus.FETCHING;
    case getSuccessActionName(TopLevelMethod.GET_MARKERS):
      return DetailedLoadStatus.OK;
    case getFailActionName(TopLevelMethod.GET_MARKERS):
      return DetailedLoadStatus.ERROR;
    default:
      return state;
  }
};

const markerLoadStatus = (state = DetailedLoadStatus.WAITING, action) => {
  switch (action.type) {
    case getStartActionName(ViewerMethod.GET_HIGHLIGHTS):
      return DetailedLoadStatus.FETCHING;
    case getSuccessActionName(ViewerMethod.GET_HIGHLIGHTS):
      return DetailedLoadStatus.OK;
    case getFailActionName(ViewerMethod.GET_HIGHLIGHTS):
      return DetailedLoadStatus.ERROR;
    default:
      return state;
  }
};

export const highlightsSubscribedMarkers = (
  state: MarkerData[] = [],
  action
) => {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.GET_HIGHLIGHTS):
      let subscribedMarkers = action.resultData.subscribedMarkers;
      return subscribedMarkers;
    default:
      return state;
  }
};

const activeMarkerId = (state = "", action) => {
  switch (action.type) {
    case getSuccessActionName(ViewerMethod.HIGHLIGHT_CURRENT_SELECTION):
    case getSuccessActionName(ViewerMethod.UPDATE_HIGHLIGHT):
      return action.resultData.markerId;
    default:
      return state;
  }
};

export default combineReducers({
  markerIds,
  markerData,
  activeMarkerId,
  colorOptions,
  markerLoadStatus,
  colorOptionsLoadStatus,
  highlightsSubscribedMarkers,
});
